var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOngoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9987 0.333984C7.8087 0.333984 0.332031 7.81065 0.332031 17.0007C0.332031 26.1907 7.8087 33.6673 16.9987 33.6673C26.1887 33.6673 33.6654 26.1907 33.6654 17.0007C33.6654 7.81065 26.1887 0.333984 16.9987 0.333984ZM22.487 24.8457L15.332 17.6906V7.00065H18.6654V16.3107L24.8437 22.489L22.487 24.8457Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoing);
export default __webpack_public_path__ + "static/media/ongoing.9cbf95b004a262c291f9e0d0cb2b84e0.svg";
export { ForwardRef as ReactComponent };